module.exports = __webpack_public_path__ + "static/img/ai50.31750ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ai50.png
// module id = hPCE
// module chunks = 1